import React from 'react';
import { useForm } from "react-hook-form";
import { Table, Modal, ModalBody, ModalFooter, ModalHeader, Button, Form, Alert } from 'reactstrap';

import FormInput from '../../components/Controls/FormInput';
import FormSubmitButton from '../../components/Controls/FormSubmitButton';
import videoPlatformMediaService from '../../services/videoPlatformMediaService';
import utility from '../../services/utility';

const MediaPurgeConfirmation = ({ data, onCancel, onSubmitted }) => {
    const validations = {
        passwordConfirm: {
            required: "Password is required",
        }
    }

    const { register, handleSubmit, formState } = useForm();
    const { errors, isSubmitting } = formState;

    const onSubmit = async (formData) => {
        await videoPlatformMediaService.purge(data.show, data.startDate, data.endDate, formData.passwordConfirm).then(response => {
            onSubmitted && onSubmitted(data);
        })
    };

    return (
        <Modal
            autoFocus={false}
            isOpen={data !== null}
            size="lg"
            
            modalTransition={{ timeout: 500 }}>
            <ModalHeader tag="h3">
                Confirmation
            </ModalHeader>
            <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>

                <ModalBody>
                    <Alert color="danger">
                        You are about to delete the following medias from Limelight and the MediaFlow database.
                    </Alert>
                    <Table>
                        <tbody>
                            <tr>
                                <th className="align-middle border-0 pl-0">Oldest media</th>
                                <td className="border-0"><strong>{data?.oldest?.title}</strong>
                                    <div>{
                                        (
                                            data?.oldest?.createdDate && utility.formatDateTimeString(data.oldest.createdDate)
                                        )
                                        || "N/A"
                                    }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="align-middle pl-0">Newest media</th>
                                <td><strong>{data?.newest?.title}</strong>
                                    <div>{
                                        (
                                            data?.newest?.createdDate && utility.formatDateTimeString(data.newest.createdDate)
                                        )
                                        || "N/A"
                                    }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="pl-0">Total medias to be deleted
                                </th>
                                <td>
                                    <strong>{data?.count ?? 0}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <FormInput
                        register={register}
                        name="passwordConfirm"
                        type="password"
                        labelText="Type your password to confirm"
                        validations={validations.passwordConfirm}
                        errors={errors.passwordConfirm}
                        autoFocus
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" type="button" onClick={onCancel} disabled={isSubmitting}>Cancel</Button>
                    <FormSubmitButton
                        text="Confirm and purge"
                        isSubmitting={isSubmitting} />
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default MediaPurgeConfirmation;